import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RegistrationForm from "./components/RegistrationForm";
import SuccessPage from "./components/SuccessPage";
import SetPasswordComplete from "./components/SetPasswordComplete";
import ProvisioningPage from "./components/ProvisioningPage";
import "./App.css";

function App() {
  const [marketplaceToken, setMarketplaceToken] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("x-amzn-marketplace-token");
    if (token) {
      setMarketplaceToken(token);
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to={`/registrations${window.location.search}`} replace />} />
        <Route
          path="/registrations"
          element={<RegistrationForm marketplaceToken={marketplaceToken} />}
        />
        <Route path="/registrations/set-password-complete" element={<SetPasswordComplete />} />
        <Route path="/registrations/provisioning" element={<ProvisioningPage />} />
        <Route path="/registrations/complete" element={<SuccessPage />} />
      </Routes>
    </div>
  );
}

export default App;
